import { useScrollProgress } from "../hooks/useScrollProgress";
import { usePrefersReducedMotion } from "../hooks/usePrefersReducedMotion";

type ScrollProgressBarProps = {
  color?: string;
  widthPx?: number;
};

/**
 * Fixed pionowy pasek na lewej krawędzi ekranu, wypełniający się wraz
 * z postępem scrolla całej strony. To ten sam motyw co zielony signature bar
 * na grafikach LinkedIn - tylko tutaj funkcjonalny, nie dekoracyjny.
 *
 * Wstaw raz, obok <GrainOverlay /> na poziomie App.
 * Przy prefers-reduced-motion pasek nadal pokazuje postęp (to informacja,
 * nie animacja ambientowa), ale bez transition na scaleY - skacze od razu.
 */
export function ScrollProgressBar({ color = "#BEF264", widthPx = 4 }: ScrollProgressBarProps) {
  const progress = useScrollProgress();
  const reducedMotion = usePrefersReducedMotion();

  return (
    <div
      aria-hidden="true"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: widthPx,
        height: "100vh",
        zIndex: 9998,
        pointerEvents: "none",
        background: "rgba(255,255,255,0.06)",
      }}
    >
      <div
        style={{
          width: "100%",
          height: `${progress * 100}%`,
          background: color,
          transformOrigin: "top",
          transition: reducedMotion ? "none" : "height 80ms linear",
        }}
      />
    </div>
  );
}
